<template>
    <div class="main">
        <div class="header">
            <div class="header_title">
                <div :style="{color: (deductList.enterpriseName === undefined || deductList.enterpriseName === null || deductList.enterpriseName === '' )? '#999': '#000'}">
                    {{(deductList.enterpriseName === undefined || deductList.enterpriseName===null || deductList.enterpriseName==="")? "暂无数据": deductList.enterpriseName}}
                </div>
                <div>
                    <p :style="{color: (deductList.score === undefined || deductList.score === null || deductList.score === '' )? '#999': '#333333'}">
                        {{(deductList.score === undefined || deductList.score === null || deductList.score === '')?'暂无数据':('-' + deductList.score)}}
                    </p>
                    <p :style="{color: (deductList.stateName === undefined || deductList.stateName === null || deductList.stateName === '' )? '#999': '#36B374'}">
                        {{(deductList.stateName === undefined || deductList.stateName ===null || deductList.stateName === '')?'暂无数据':deductList.stateName}}
                    </p>
                </div>
            </div>
            <div class="header_text">
                <div class="header_left">
                    <div :style="{color: (deductList.detailName === undefined || deductList.detailName === null || deductList.detailName === '' )? '#999': '#666666'}">
                        {{(deductList.detailName === undefined || deductList.detailName === null || deductList.detailName === '')?'暂无数据':deductList.detailName}}
                    </div>
                    <div :style="{color: (deductList.createTime === undefined || deductList.createTime === null || deductList.createTime === '' )? '#999': '#666666'}" v-show='deductList.createTime'>
                        {{ deductList.createTime|filtTime}}
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content_view">
                <div class="line_bottom">
                    <div :value="this.reasonType.text === ''?'待选择':this.reasonType.text" @click="goClick" class="offwhy">
                        <div>下线原因</div>
                        <div>
                            <p>{{this.reasonType.text === ''?'待选择':this.reasonType.text}}</p>
                            <p>
                                <img src="../../../../assets/integrity/right@3x.png" alt="">
                            </p>
                        </div>
                    </div>
                    <!-- <cell title="下线原因" is-link  :value="this.reasonType.text === ''?'待选择':this.reasonType.text" @click="goClick">

                    </cell> -->
                </div>
                <div class="content_text">
                    <div class="content_text-header">
                        <span>下线说明</span>
                        <span>必填</span>
                    </div>
                    <div class="content_text-center">
                        <van-field
                            v-model.trim="msg"
                            rows="2"
                            autosize
                            type="textarea"
                            placeholder="请在这里补充下线说明"
                        />
                    </div>
                </div>
                <div class="content_text">
                    <div class="content_text-up">
                        <upload :imgUrl="imgUrl"></upload>
                    </div>
                </div>
            </div>
            <div class="content_bottom" @click="sureDelete">
                <div class="content_btn">确定下线</div>
            </div>
        </div>
        <common-picker v-if="isShow" ref="commonPicker2" :typeList="revocationReasonList" :cols="chnnerCol" @getTypeValue='getTypeValue'></common-picker>

    </div>
</template>
<script>
    import commonPicker from '../../../components/base/commonPicker';
    import Upload from '../../components/Upload'
    // import { channer } from '../../../../utils/configJson';
    import api from '../../../../service/modules/integrity'
    import { Toast } from 'vant';
    export default {
        name: 'referralPoints',
        components: {
            commonPicker,
            Upload
        },
        data () {
            return {
                revocationReasonList: [],
                isShow: false,
                // typeList2: channer,
                chnnerCol: 1,
                reasonType: { text: '', value: '' },
                msg: '',
                // 上传绑定的IMG数组
                imgUrl: [],
                enterpriseId: '',
                deductList: {},
                deductId: ''
            }
        },
        created () {
            this.enterpriseId = this.$route.params.enterpriseId; // 企业ID
            this.deductId = this.$route.params.deductId;
            // 获取下线原因List
            this.getRevocationReason();
            // 获取对应扣分详情
            this.getDeductDetail();
        },
        mounted () {
            // console.log('this', this.reasonType)
            this.$on('fileUploadData', val => {
                this.imgUrl = val
            })
        },
        methods: {
            goClick () {
                this.$refs.commonPicker2.showPicker();
            },
            // 获取对应扣分详情
            getDeductDetail () {
                let data = {
                    deductId: this.deductId
                }
                api.deductDetail(data).then(res => {
                    this.deductList = res.data
                    // console.log('下线扣分', this.deductList)
                })
            },
            // 获取下线原因List
            getRevocationReason () {
                let params = {
                    dictType: 'REVOCATION_REASON'
                }
                api.dictType(params).then(res => {
                    // console.log(res)
                    let arr = [];
                    for (let i = 0, length = res.data.length; i < length; i++) {
                        arr[i] = {};
                        arr[i].text = res.data[i].name;
                        arr[i].value = res.data[i].code;
                    }
                    this.revocationReasonList[0] = arr;
                    this.isShow = true
                })
            },
            // 选择下线type原因
            getTypeValue (val) {
                // console.log('原因', val);
                this.reasonType.text = val[0].text;
                this.reasonType.value = val[0].value;
            },
            // 确定下线扣分
            sureDelete () {
                if (this.reasonType.value === '') {
                    Toast('请选择下线原因');
                } else if (this.msg === '') {
                    this.msg += '.';
                    this.msg = ''
                    Toast('下线说明不能为空');
                } else if (this.reasonType.value === '') {
                    this.reasonType.text = '';
                    this.reasonType.value = '';
                    Toast('下线原因不能为空');
                } else {
                    let attachs = [...this.imgUrl]
                    if (attachs) {
                        attachs.map(item => { delete item.url })
                    }
                    let data = {
                        id: this.deductId,
                        cancelRemark: this.msg,
                        revocationReason: this.reasonType.value,
                        cancelAttach: JSON.stringify(attachs)// 附件图片
                    }
                    api.cancel(data).then(res => {
                        if (res.ret === 0) {
                            let state = {
                                success: true,
                                msg: '下线成功'
                            }
                            state = JSON.stringify(state)
                            localStorage.setItem('referraState', state)
                            this.$router.back();
                            // this.$Toast.fail(res.msg);
                        }
                    })
                }
            }
        },
        // 时间搓
        filters: {
            filtTime (str) {
                var date = new Date(str); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M =
                    (date.getMonth() + 1 < 10
                        ? '0' + (date.getMonth() + 1)
                        : date.getMonth() + 1) + '-';
                var D =
                    (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h =
                    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m =
                    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                    ':';
                var s =
                    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    }
</script>
<style lang="less" scoped>
.main {
    background: #eee;
    width: 100%;
    height: 100vh;
    .header {
        width: 100%;
        background: #fff;
        padding: 24px 12px;
        .header_title {
            font-size: 16px;
            display: flex;
            line-height: 24px;
            font-weight: bold;
            div:nth-child(1) {
                width: 291px;
                margin-right: 24px;
            }
            div:nth-child(2) {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                p:nth-child(1) {
                    font-size: 20px;
                    font-weight: bold;
                }
                p:nth-child(2) {
                    font-size: 12px;
                }
            }
        }
        .header_text {
            margin-top: 16px;
            .header_left {
                width: 100%;
                div:nth-child(1) {
                    font-size: 14px;
                }
                div:nth-child(2) {
                    font-size: 12px;
                    margin-top: 12px;
                }
            }
        }
    }
    .content {
        background: #fff;
        height: 100%;
        .content_view {
            .line_bottom {
                padding: 0px 12px;
                position: relative;
                border: none;
                .offwhy {
                    display: flex;
                    justify-content: space-between;
                    padding: 15px 0px;
                    font-size: 14px;
                    color: #999999;
                    position: relative;
                    border: none;
                    div:nth-child(2) {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p>img {
                            width: 12px;
                            height: 12px;
                            margin-left: 4px;
                        }
                    }
                }
                .offwhy:after {
                content:'';
                    position:absolute;
                    bottom: 0;
                    left: 0;
                    background: #eeeeee;
                    width:100%;
                    height: 1px;
                    -webkit-transform:scaleY(0.5);
                    transform:scaleY(0.5);
                    -webkit-transform-origin: 0 0;
                    transform-origin: 0 0;
                }
            }
            .line_bottom:before {
                content:'';
                position:absolute;
                top: 0;
                left: 0;
                background:#eeeeee;
                width:100%;
                height: 1px;
                -webkit-transform:scaleY(0.5);
                transform:scaleY(0.5);
                -webkit-transform-origin: 0 0;
                transform-origin: 0 0;
            }
            .van-cell__title {
                color: #999999;
            }
            .content_text {
                padding: 0 12px;
                .content_text-header {
                    padding: 16px 0 12px 0;
                    span:nth-child(1) {
                        font-size: 14px;
                        color: #999999;
                    }
                    span:nth-child(2) {
                        font-size: 12px;
                        color: #999999;
                        margin-left: 4px;
                    }
                }
                .van-cell {
                    height:180px;
                    background:rgba(249,249,249,1);
                    border-radius:3px;
                    padding:16px;
                }
                .content_text-up {
                    padding: 20px 0;
                }
            }
        }
        .content_bottom {
            width: 100%;
            height: 74px;
            padding: 12px;
            background: #fff;
            position: fixed;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background:rgba(255,255,255,1);
            box-shadow:0px -2px 8px 0px rgba(0,0,0,0.03);
            .content_btn {
                background: #36B374;
                color: #fff;
                font-size: 16px;
                height: 100%;
                width: 100%;
                border-radius: 3px;
                text-align: center;
                line-height: 50px;
            }
        }
    }
}
</style>
